import { LocalHospital, MonitorHeart, Scale } from "@mui/icons-material";
import {
  alpha,
  Card,
  CardContent,
  Grid,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function HealthSummary({ data }) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
          <LocalHospital color="primary" sx={{ fontSize: 28 }} />
          <Typography variant="h5" fontWeight={700}>
            {t("HealthSummary")}
          </Typography>
        </Stack>

        <Grid container spacing={{ xs: 2, sm: 3 }}>
          <HealthCard
            icon={<Scale color="info" sx={{ fontSize: 40, mb: 2 }} />}
            title={t("LastWeight")}
            value={data?.weight || "-"}
            color={theme.palette.info.main}
          />

          <HealthCard
            icon={<MonitorHeart color="success" sx={{ fontSize: 40, mb: 2 }} />}
            title={t("LastTemp")}
            value={data?.temperature || "-"}
            color={theme.palette.success.main}
          />

          <HealthCard
            icon={
              <LocalHospital color="warning" sx={{ fontSize: 40, mb: 2 }} />
            }
            title={t("FIVFeLVStatus")}
            value={data?.fivFelv ? data.fivFelv : "-"}
            color={theme.palette.warning.main}
          />
        </Grid>
      </CardContent>
    </Card>
  );
}

function HealthCard({ icon, title, value, color }) {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Paper
        sx={{
          p: 3,
          textAlign: "center",
          background: `linear-gradient(135deg, ${alpha(color, 0.1)} 0%, ${alpha(
            color,
            0.05,
          )} 100%)`,
          border: `1px solid ${alpha(color, 0.2)}`,
          borderRadius: 3,
          height: "100%",
          transition: "all 0.2s ease-in-out",
          "&:hover": { cursor: "default" },
        }}
      >
        {icon}
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        <Typography variant="h5" fontWeight={800} color={color} gutterBottom>
          {value}
        </Typography>
      </Paper>
    </Grid>
  );
}
